// =============================================================================
// BDR Public Pages V2 — SEO single source of truth
// -----------------------------------------------------------------------------
// `quote` is still IDENTICAL to prod (GetAQuote.jsx:308-309). `home` and
// `ourDoors` INTENTIONALLY DIVERGE from prod as of the v2 redesign: the service
// area was broadened from "San Antonio" only to "San Antonio, the Texas Hill
// Country, and South Texas" (v2-only — prod Home.jsx/OurDoors.jsx unchanged).
// If prod later adopts the same copy, re-sync here.
// =============================================================================

export const SEO_V2 = {
  home: {
    title:
      "Biggin's Door Refinishing | Wood Door Refinishing in San Antonio & the Hill Country",
    description:
      "Wood door refinishing experts serving San Antonio, the Texas Hill Country, and South Texas — interior, exterior, and commercial. Family-owned since 2012.",
  },
  quote: {
    title: "Request A Quote | Biggin's Door Refinishing",
    description:
      "Free, no-obligation estimates for interior, exterior, and commercial wood door refinishing in the San Antonio area.",
  },
  ourDoors: {
    title: "Our Refinished Doors | Biggin's Door Refinishing",
    description:
      "Browse our before-and-after gallery of recent door refinishing projects across San Antonio, the Texas Hill Country, and South Texas.",
  },
};

export default SEO_V2;
